<template>
    <div id="company">

        <Head></Head>

        <div v-show="selectVisible">
            <h3>选择公司</h3>
            <el-select v-model="value" placeholder="请选择公司" @change="selectCompany">
                <el-option v-for="item in companyList" :key="item.id" :label="item.companyName" :value="item.id">
                </el-option>
            </el-select>

            <el-divider content-position="center"><span style="color:green">或</span></el-divider>
            <el-button @click="createNew" type="danger" plain>创建新公司</el-button>
            <el-button @click="exit" type="danger" plain>退出系统</el-button>
        </div>

        <el-form ref="form" :model="form" label-width="80px" v-show="formVisible">
            <p></p>

            <el-form-item label="公司名称" :label-width="formLabelWidth">
                <el-input v-model="form.companyName"></el-input>
            </el-form-item>

            <el-form-item label="营业执照" :label-width="formLabelWidth">
                <el-upload class="avatar-uploader" action="#" :http-request="uploadLicense" :show-file-list="false"
                    :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">

                    <!-- <img :src="form.businessLicense" class="avatar"> -->
                    <i class="el-icon-plus avatar-uploader-icon"></i>

                </el-upload>
            </el-form-item>

            <p style="color:coral;">请下载<a @click="downloadDocx"
                    style="color:blue;cursor: pointer;">《标准授权委托书》</a>后填写打印，并盖章后上传扫描件。支持JPG、PNG</p>
            <el-form-item label="授权委托书" :label-width="formLabelWidth">
                <el-upload class="avatar-uploader" action="#" :http-request="uploadMandate" :show-file-list="false"
                    :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">

                    <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>

            <el-form-item>
                <el-button type="danger" @click="onSubmit">立即创建</el-button>
                <el-button @click="cancelCreate">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Head from "@/views/Head.vue";

export default {
    data() {
        return {
            token: this.getToken(),
            userId: this.getUserId(),

            companyList: [],
            value: '',
            formLabelWidth: '140px',

            selectVisible: true,
            formVisible: false,

            form: {
                companyName: '',
                licenseFile: null,
                mandateFile: null
            }
        }
    },
    components: {
        Head
    },
    methods: {
        downloadDocx() {
            this.$axios({
                method: "get",
                url: "https://www.ctshake.cn/file/标准授权委托书.docx",
                data: {
                },
                headers: {
                    token: this.token
                },
                responseType: 'arraybuffer'
            }).then(result => {

                const data = result.data

                let objectUrl = result.config.url
                const blob = new Blob([data], {
                    type: 'application/vnd.ms-excel;charset=utf-8'
                })

                objectUrl = URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = objectUrl

                a.download = "标准授权委托书.docx"
                a.click()
                a.remove()
                URL.revokeObjectURL(objectUrl)
            })
        },
        uploadLicense(f) {
            console.log('uploadLicense')
            console.log(f)

            this.form.licenseFile = f.file

            this.$message({
                message: '上传完成',
                duration: "3000"
            })
        },
        uploadMandate(f) {

            this.form.mandateFile = f.file

            this.$message({
                message: '上传完成',
                duration: "3000"
            })
        },
        selectCompany(value) {

            this.$axios({
                method: "put",
                url: "/shiro/sys/token/modify",
                data: {
                    companyId: value,
                    userId: this.userId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.data != null) {
                    this.setToken(data.data)
                }

                this.setCompanyId(value)

                this.setPersonalCenter(0)

                this.$router.push({
                    path: "/home"
                })
            })

        },
        createNew() {
            this.selectVisible = false
            this.formVisible = true
        },
        cancelCreate() {
            this.formVisible = false
            this.selectVisible = true
        },
        onSubmit() {
            const form = new FormData()

            form.append('companyName', this.form.companyName)
            form.append('licenseFile', this.form.licenseFile)

            form.append('mandateFile', this.form.mandateFile)
            form.append('userId', this.userId)

            this.$axios({
                method: "post",
                url: "/shiro/company/add",
                data: form,
                headers: {
                    token: this.token
                }
            }).then(result => {
                //alert(result)

                this.formVisible = false
                this.selectVisible = true

                this.getAllCompany()
            })

        },
        getAllCompany() {
            this.$axios({
                method: "post",
                url: "/shiro/company/getAll",
                data: {
                    userId: this.userId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                //console.log(result.data)

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.companyList = data.data
            })
        },
        exit() {
            this.$axios({
                method: "POST",
                url: "/shiro/sys/logout",
                data: {},
                headers: {
                    token: this.token
                }
            }).then(result => {
                if (result.status === 200) {

                    const data = result.data

                    if (data.status === 200) {
                        this.$message({
                            showClose: true,
                            message: data.msg,
                            type: "success",
                            duration: "1600"
                        })
                    } else {
                        this.$message({
                            showClose: true,
                            message: data.msg,
                            type: "error",
                            duration: "3000"
                        })
                    }

                    this.setToken("")

                    this.$router.push({ path: "/Login" })
                } else {
                    this.$message({
                        showClose: true,
                        message: "操作失败，请联系管理员",
                        type: "error",
                        duration: "3000"
                    })
                }
            })
        }
    },
    mounted() {

        let url = window.location.href

        // console.log('url')
        // console.log(url)

        let str = url.substring(url.indexOf('?') + 1)
        let arrs = str.split('&')
        let result = {}

        arrs.forEach(item => {
            let keyArr = item.split('=')
            let name = keyArr[0];
            let value = keyArr[1];
            result[name] = value;
        })

        if (Object.keys(result).length > 1) {
            // console.log(result)
            // console.log('result.token')
            // console.log(result.token)

            this.setToken(result.token)

            // console.log('result.userId')
            // console.log(result.userId)

            this.setUserId(result.userId)
        }

        this.getAllCompany()
    }
}
</script>

<style>
#company {
    width: 500px;
    height: 200px;
    position: relative;
    margin: auto;
    padding-top: 100px;
    color: green;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 118px;
    height: 118px;
    line-height: 118px;
    text-align: center;
}
</style>